import { c as _c } from "react/compiler-runtime";
import { type BusinessVaultFormData, COUNTRIES, VAULT_DOT_SEPARATOR } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type BusinessAddressProps = {
  locale: Locale;
};
export const BusinessAddress = t0 => {
  const $ = _c(91);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = COUNTRIES.filter(_temp);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const usOnlyCountries = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoBuilding24 color="primary" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex flex-col gap-1"><div className="flex gap-1 items-center">{t3}<span className="text-label-2 text-primary">{t4}</span></div></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== locale) {
    t6 = {
      locale
    };
    $[7] = locale;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp3);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t(_temp4);
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t(_temp5);
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp6);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp7);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t) {
    t12 = t(_temp8);
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t(_temp9);
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t(_temp10);
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t(_temp11);
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t16 = {
      country: t7,
      addressLine1: t8,
      addressLine1International: t9,
      addressLine2: t10,
      addressLine2International: t11,
      city: t12,
      state: t13,
      stateInternational: t14,
      zip: t15
    };
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t(_temp12);
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t) {
    t18 = t(_temp13);
    $[39] = t;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t(_temp14);
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t(_temp15);
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t(_temp16);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t(_temp17);
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t(_temp18);
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t) {
    t24 = t(_temp19);
    $[51] = t;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t17 || $[54] !== t18 || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24) {
    t25 = {
      country: t17,
      addressLine1: t18,
      addressLine2: t19,
      addressLine2International: t20,
      city: t21,
      state: t22,
      stateInternational: t23,
      zip: t24
    };
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t) {
    t26 = t(_temp20);
    $[62] = t;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t) {
    t27 = t(_temp21);
    $[64] = t;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== t) {
    t28 = t(_temp22);
    $[66] = t;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t) {
    t29 = t(_temp23);
    $[68] = t;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t) {
    t30 = t(_temp24);
    $[70] = t;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t26 || $[73] !== t27 || $[74] !== t28 || $[75] !== t29 || $[76] !== t30) {
    t31 = {
      country: t26,
      addressLine1: t27,
      city: t28,
      state: t29,
      zip: t30
    };
    $[72] = t26;
    $[73] = t27;
    $[74] = t28;
    $[75] = t29;
    $[76] = t30;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== t) {
    t32 = t(_temp25);
    $[78] = t;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== t32) {
    t33 = {
      countryDisabled: t32
    };
    $[80] = t32;
    $[81] = t33;
  } else {
    t33 = $[81];
  }
  let t34;
  if ($[82] !== t16 || $[83] !== t25 || $[84] !== t31 || $[85] !== t33 || $[86] !== t6) {
    t34 = <Form.AddressLines prefix="business" vaultSeparator={VAULT_DOT_SEPARATOR} required={true} l10n={t6} countries={usOnlyCountries} labels={t16} placeholders={t25} errors={t31} hints={t33} />;
    $[82] = t16;
    $[83] = t25;
    $[84] = t31;
    $[85] = t33;
    $[86] = t6;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== t34 || $[89] !== t5) {
    t35 = <div className="flex flex-col gap-4">{t5}{t34}</div>;
    $[88] = t34;
    $[89] = t5;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  return t35;
};
function _temp(c) {
  return c.value === "US";
}
function _temp2($) {
  return $.fields.address.sectionTitle;
}
function _temp3($_0) {
  return $_0.fields.address.country.label;
}
function _temp4($_1) {
  return $_1.fields.address.addressLine1.label;
}
function _temp5($_2) {
  return $_2.fields.address.addressLine1.internationalLabel;
}
function _temp6($_3) {
  return $_3.fields.address.addressLine2.label;
}
function _temp7($_4) {
  return $_4.fields.address.addressLine2.internationalLabel;
}
function _temp8($_5) {
  return $_5.fields.address.city.label;
}
function _temp9($_6) {
  return $_6.fields.address.state.label;
}
function _temp10($_7) {
  return $_7.fields.address.state.internationalLabel;
}
function _temp11($_8) {
  return $_8.fields.address.zip.label;
}
function _temp12($_9) {
  return $_9.fields.address.country.placeholder;
}
function _temp13($_10) {
  return $_10.fields.address.addressLine1.placeholder;
}
function _temp14($_11) {
  return $_11.fields.address.addressLine2.placeholder;
}
function _temp15($_12) {
  return $_12.fields.address.addressLine2.internationalPlaceholder;
}
function _temp16($_13) {
  return $_13.fields.address.city.placeholder;
}
function _temp17($_14) {
  return $_14.fields.address.state.placeholder;
}
function _temp18($_15) {
  return $_15.fields.address.state.internationalPlaceholder;
}
function _temp19($_16) {
  return $_16.fields.address.zip.placeholder;
}
function _temp20($_17) {
  return $_17.fields.address.country.error;
}
function _temp21($_18) {
  return $_18.fields.address.addressLine1.error;
}
function _temp22($_19) {
  return $_19.fields.address.city.error;
}
function _temp23($_20) {
  return $_20.fields.address.state.error;
}
function _temp24($_21) {
  return $_21.fields.address.zip.error;
}
function _temp25($_22) {
  return $_22.fields.address.country.usOnlyHint;
}